import React from 'react'
import styles from '~/styles/atoms/progress/progress.module.scss'
import { useTranslation } from 'react-i18next'

import { addClass } from '~/common/utils/html'

interface Props {
  text: string
  active?: boolean
  completed?: boolean
}

const ProgressItem = ({text, active = false, completed = false}: Props) => {
  const { t } = useTranslation()

  return (
    <li className={styles.item + addClass(styles.active, active)}>
      <span className={styles.bar + addClass(styles.active, active)  + addClass(styles.completed, completed)}>
        {t(text)}
      </span>
    </li>
  )
}

export default ProgressItem